import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { VisibleCaptureProperty } from "../../../Model/CaptureProfile";
import { ContinuousZoom } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type ContinuousZoomControlProps = {
  disabled: boolean;
  continuousZoom: ContinuousZoom;
  captureProperty: VisibleCaptureProperty;
  onChange: (value: { continuousZoom: number }) => void;
};

export function ContinuousZoomControl({
  continuousZoom,
  captureProperty,
  disabled,
  onChange,
}: ContinuousZoomControlProps) {
  if (captureProperty.continuousZoom == null) {
    throw new Error("Capture profile continuousZoom is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Zoom"
      id={EOpticAndCameraFeature.ContinuousZoom}
      min={continuousZoom.minContinuousZoom}
      max={continuousZoom.maxContinuousZoom}
      value={captureProperty.continuousZoom}
      onValueChanged={(id, value) => {
        onChange({
          continuousZoom: value,
        });
      }}
      unit="x"
      step={0.1}
    />
  );
}
